require './base'
require '../../modules/delivery_estimates/frontend/delivery_estimates'
require '../../modules/shipping/frontend/free_shipping'
require '../../node_modules/grpn-instagram-photo-widget/frontend/coffeescripts/instagram-photo-widgets'
require '../../modules/offers/frontend/offers_timer'
require '../../modules/goods_v2/frontend/read_more'
require '../../modules/product_video/frontend/product_video'
require '../../modules/product_reviews/frontend/product_reviews'
require '../../modules/wishlist_button/frontend/wishlist'
